if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.navPrev = this.querySelector('.product-media-modal__nav--prev');
        this.navNext = this.querySelector('.product-media-modal__nav--next');

        if (this.navPrev) {
          // Stop pointerup from bubbling to ModalDialog's close handler
          this.navPrev.addEventListener('pointerup', (e) => e.stopPropagation());
          this.navPrev.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigate(-1);
          });
        }
        if (this.navNext) {
          this.navNext.addEventListener('pointerup', (e) => e.stopPropagation());
          this.navNext.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigate(1);
          });
        }

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      navigate(direction) {
        const items = this.mediaItems;
        const activeIndex = items.findIndex((el) => el.classList.contains('active'));
        if (activeIndex === -1) return;

        let newIndex = activeIndex + direction;
        if (newIndex < 0) newIndex = items.length - 1;
        if (newIndex >= items.length) newIndex = 0;

        items.forEach((el) => el.classList.remove('active'));
        items[newIndex].classList.add('active');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
